import Link from "next/link";
import { cn } from "@/lib/utils";

export default function SignUpButton({ referral, className, text = "Sign Up Free" }) {
    const href = referral ? `/sign-up?referral=${referral}` : "/sign-up";

    return (
        <Link
            href={href}
            className={cn(
                "inline-block px-4 py-2 text-sm md:text-base font-medium text-white bg-blue-600 rounded-full hover:bg-blue-700 transition-colors shadow-xs w-full md:w-auto text-center",
                className
            )}
        >
            {text}
        </Link>
    );
}
